// NavigationPromoBanner.tsx

import { Flex, Box, useBreakpointValue, chakra } from "@chakra-ui/react";
import React, { useCallback, useState, useEffect } from "react";
import { keccak256, stringToBytes } from "viem";

import config from "configs/app";
import useIsMobile from "lib/hooks/useIsMobile";
import { Tooltip } from "toolkit/chakra/tooltip";
import IconSvg from "ui/shared/IconSvg";

import NavigationPromoBannerContent from "./NavigationPromoBannerContent";

const PROMO_BANNER_CLOSED_HASH_KEY = "nav-promo-banner-closed-hash";
const promoBanner = config.UI.navigation.promoBanner;
const isHorizontal = config.UI.navigation.layout === "horizontal";

type Props = {
  isCollapsed?: boolean;
};

const NavigationPromoBanner = ({ isCollapsed }: Props) => {
  const isMobile = useIsMobile();
  const isXLScreen = useBreakpointValue({ base: false, xl: true });
  const isHorizontalNavigation = isHorizontal && !isMobile;

  const [isShown, setIsShown] = useState(false);
  const [promoBannerHash, setPromoBannerHash] = useState("");

  useEffect(() => {
    try {
      const promoBannerClosedHash = window.localStorage.getItem(
        PROMO_BANNER_CLOSED_HASH_KEY
      );
      const promoBannerHash = keccak256(
        stringToBytes(JSON.stringify(promoBanner))
      );
      setIsShown(promoBannerHash !== promoBannerClosedHash);
      setPromoBannerHash(promoBannerHash);
    } catch {}
  }, []);

  const handleClose = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
      localStorage.setItem(PROMO_BANNER_CLOSED_HASH_KEY, promoBannerHash);
      setIsShown(false);
    },
    [promoBannerHash]
  );

  const isTooltipDisabled =
    isMobile ||
    (!isHorizontalNavigation &&
      (isCollapsed === false || (isCollapsed === undefined && isXLScreen)));

  if (!promoBanner || !isShown) {
    return null;
  }

  // Advertisement / promo banner display commented out (reversible)
  // return (
  //   <Flex flex={1} mt={isHorizontalNavigation ? 0 : 3} pointerEvents="none">
  //     <chakra.a href={promoBanner.link_url} ...>
  //       <Tooltip ...>
  //         <Box w="full" position="relative">
  //           <NavigationPromoBannerContent ... />
  //           <IconSvg onClick={handleClose} name="close" ... />
  //         </Box>
  //       </Tooltip>
  //     </chakra.a>
  //   </Flex>
  // );
  return null;
};

export default NavigationPromoBanner;
